import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faList } from '@fortawesome/free-solid-svg-icons'
import Header from './header'

const chevronLeft = <FontAwesomeIcon icon={ faChevronLeft } />
const listIcon = <FontAwesomeIcon icon={ faList } />

function Code(props) {
  return (
    <div className="layout">
      <Header />
      <div className="content">
        <div className="animate__animated animate__bounceIn category">
            <div className="group">
              <h3>{ props.title }</h3>
              <p className="subtitle">{ props.subtitle }</p>
              <div className="row item-list">
                <div className="result">
                  <code className="pid-code">
                    Product code: {' '}
                    { props.code }
                  </code>
                </div>
              </div>
            </div>
            <div className="navigation">
              <div className="row">
                <div className="col prev">
                  <Link to={'/' + props.prevStep}>
                    {chevronLeft}{props.prev}
                  </Link>
                </div>
                <div className="col next">
                  <Link to={'/' + props.nextStep}>
                    {listIcon}{props.next}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}

export default Code